<template>
    <div class="skeleton-loader">
        <div v-for="(row, i) in skeletonData.rows" class="row" :key="`row-${i}`">
            <div v-for="(column, j) in row.columns" :class="column.colSize" :key="`col-${j}`">
                <div class="row">
                    <div v-for="(innerColumn, k) in column.innerColumns"
                         class="mb-4"
                         :key="`inner${k}`"
                         :class="innerColumn.colSize">
                        <div class="p-3 pb-2 bg-white border shadow-sm">
                            <div v-for="num in innerColumn.height" :key="`height-${num}`"
                                 class="skeleton-loader__container my-4 overflow-hidden"
                                 :style="getLineWidth()">
                                <div class="skeleton-loader__animated-line p-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'skeleton-loader',
        props: {
            skeletonData: {
                type: Object,
                required: true,
            },
        },
        data: () => ({lineSizes: [30, 40, 50, 60, 70, 80, 90]}),
        methods: {
            getLineWidth() {
                return `width: ${this.lineSizes[Math.floor(Math.random()*this.lineSizes.length)]}%`;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .skeleton-loader {
        &__container {
            background: #f6f6f6;
        }
        &__animated-line {
            animation: backgroundMove 2.5s linear infinite forwards;
            background: -webkit-linear-gradient(left, #f6f6f6 0%, #eeeeee 60%, #f6f6f6 80%, #f6f6f6 100%) no-repeat;
        }
    }
    @keyframes backgroundMove {
        0% {
            transform: translateX(-640px);
        }
        100% {
            transform: translateX(640px);
        }
    }
</style>